export default "__VITE_ASSET__DhASzMkT__"